import React, { useContext } from 'react';
import classNames from 'classnames';
import { FeedContext } from '../FeedContext';
import config from '../config';
import Spinner from '../components/Spinner';
import LoadMore from './LoadMore';
import ListItem from './ListItem';

const buildList = (posts, perPage) => {
  return posts.map((post, index) => {
    const delay = index % perPage;

    if (posts) {
      return (
        <div className="c-jobs-feed-list__item" key={post.title}>
          <ListItem {...post} />
        </div>
      );
    } else {
      return false;
    }
  });
};

function Results({ posts, hasMorePosts, perPage, loading }) {
  const context = useContext(FeedContext);
  const listElements = buildList(posts, perPage);

  const componentClass = classNames({
    'l-jobs-feed-list__results': true,
    'l-jobs-feed-list__results--loading': loading,
  });

  return (
    <>
      <div className={componentClass}>
      <div className="c-jobs-feed-list__header">
        <div>{config.text.jobTitle}</div>
        <div>{config.text.location}</div>
      </div>
        {loading ? (
          <Spinner />
        ) : listElements.length ? (
          listElements
        ) : (
          <h3 className="l-feed__not-found">{config.text.notFound}</h3>
        )}
      </div>

      {hasMorePosts && (
        <LoadMore text={config.text.loadMore} clickHandler={context.loadMore} />
      )}
    </>
  );
}

export default Results;
